import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store";

const selectAuthState = (state: RootState) => state.auth;

export const selectUser = createSelector(
  [selectAuthState],
  (auth) => auth.user
);

export const selectIsAuthenticated = createSelector(
  [selectAuthState],
  (auth) => auth.isAuthenticated
);

export const selectIsLoading = createSelector(
  [selectAuthState],
  (auth) => auth.isLoading
);

export const selectAuthError = createSelector(
  [selectAuthState],
  (auth) => auth.error
);

export const selectIsVisitor = createSelector(
  [selectAuthState],
  (auth) => auth.isVisitor
);

export const selectProfileLoaded = createSelector(
  [selectAuthState],
  (auth) => auth.profileLoaded
);

export const selectAuthGuardState = createSelector(
  [selectAuthState],
  (auth) => ({
    user: auth.user,
    isLoading: auth.isLoading,
    isAuthenticated: auth.isAuthenticated,
  })
);

export const selectTwoFactorStatus = createSelector(
  [selectAuthState],
  (auth) => auth.twoFactorStatus
);

export const selectSocialAccounts = createSelector(
  [selectAuthState],
  (auth) => auth.socialAccounts
);

export const selectUserRole = createSelector(
  [selectAuthState],
  (auth) => auth.user?.role
);

export const selectIsAdmin = createSelector(
  [selectUserRole],
  (role) => {
    return role === 'SUPER_ADMIN' || role === 'ADMIN';
  }
);

export const selectIsSuperAdmin = createSelector(
  [selectUserRole],
  (role) => role === 'SUPER_ADMIN'
);
